<input
  class="search-select-input"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [(ngModel)]="query"
  [matAutocomplete]="auto"
  (focus)="$any($event.target).select()"
  (blur)="onBlur()" />
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="select($event.option.value)" (closed)="restoreLabel()">
  <mat-option *ngFor="let option of filtered" [value]="option.value">{{ option.label }}</mat-option>
</mat-autocomplete>
